<template>
    <div>
        <b-modal
            id="onlineModal"
            ref="onlineModal"
            @shown="shown"
            :lazy="true"
            @hidden="close"
            :scrollable="true"
            title-tag="h2"
            title="Reject Appointment"
        >
            <form class="form-horizontal pl-2">
                <div class="form-group row">
                    <label for="staticEmail" class="col-sm-3 col-form-label"
                        >Email Message:</label
                    >
                    <div class="col-sm-9">
                        <div
                            id="reject_confirmation_message"
                            class="form-control"
                            contenteditable="true"
                        ></div>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="note" class="col-sm-3 col-form-label"
                        >Notes:</label
                    >
                    <div class="col-sm-9">
                        <textarea
                            id="notes"
                            v-model="cancellation_note"
                            class="form-control"
                            placeholder="Notes (optional)"
                            rows="5"
                            style="height: 80px;"
                        ></textarea>
                    </div>
                </div>
            </form>
            <div slot="modal-footer" class="w-100">
                <b-button
                    v-if="!loading"
                    @click="$refs.onlineModal.hide()"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-button
                >
                <div class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                    <b-button @click="save" v-else variant="primary"
                        >Reject</b-button
                    >
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            resources: {},
            data: {
                client: {},
                patient: {}
            },
            confirmation_message: null,
            cancellation_note: null,
            loading: false
        };
    },
    computed: {},
    created() {},
    methods: {
        open(id) {
            this.getAppointmentData(id);

            this.$refs.onlineModal.show();
        },
        shown() {
            // reset all data
            this.page = "appointment";
        },
        close() {
            this.$socket.client.emit("v-broadcast-all", { action: "cancel" });
        },
        getAppointmentData(id) {
            let self = this;
            return self.$http
                .get(process.env.SCHEDULE_SERVICE + "appointment/" + id)
                .then(function (response) {
                    self.data = response.data.response.resources;

                    self.getEmailMessages();
                });
        },
        async getEmailMessages() {
            let params = [];
            params[0] = {
                client_id: this.data.client.id,
                recipient_id: this.data.client.id,
                recipient_type: 0,
                patient_id: this.data.patient ? [this.data.patient.id] : [],
                appointment_id: this.data.id,
                appointment_date: this.appointment_date,
                appointment_time: this.appointment_time,
                appointment_reason: this.data.reason,
                note: this.data.note,
                email_type: this.EMAIL_TYPE.APPOINTMENT_DECLINE
            };

            let data = await $.post(
                process.env.APPS +
                    "index.php/common/appointment/getEmailTemplate",
                { params }
            );
            if (data && data.response) {
                this.confirmation_message =
                    data.response[0].email_template.message;

                $("#reject_confirmation_message").html(
                    this.confirmation_message
                );
            } else {
                this._message("Error retriving email message", "danger");
            }

            // let self = this;
            // self.params =
            //     "client_id=" +
            //     self.data.client.id +
            //     "&patient_id=" +
            //     self.data.patient.id +
            //     "&appointment_id=" +
            //     self.data.id +
            //     "&appointment_date=" +
            //     self.appointment_date +
            //     "&appointment_time=" +
            //     self.appointment_time +
            //     "&note=" +
            //     self.data.note;

            // return self.$http
            //     .get(
            //         process.env.SCHEDULE_SERVICE +
            //             "online-booking/render-reject-message?" +
            //             self.params
            //     )
            //     .then(function(response) {
            //         if (response.data.response.message.code == 200) {
            //             self.confirmation_message =
            //                 response.data.response.resources.reject_message;

            //             $("#reject_confirmation_message").html(
            //                 self.confirmation_message
            //             );
            //         }
            //     });
        },
        save() {
            let self = this;

            self.loading = true;

            let promise = Promise.resolve(true); // -- empty promise

            promise.then(result => {
                if (result) {
                    let post = {
                        cancellation_note: self.cancellation_note,
                        cancellation_reason: "BY_CLINIC"
                    };

                    post.confirmation = {
                        confirmation_method: "BY_EMAIL",
                        confirmation_subject: "",
                        confirmation_message: $(
                            "#reject_confirmation_message"
                        ).html()
                    };

                    return this.$http
                        .post(
                            process.env.SCHEDULE_SERVICE +
                                "reject-appointment/" +
                                self.data.id,
                            post
                        )
                        .then(function (response) {
                            if (response.data.response.message.code === 200) {
                                self._message("Appointment cancelled");
                                self.$refs.onlineModal.hide();
                                self.$parent.refetch();
                            } else {
                                self.$root.$emit(
                                    "message",
                                    "Error processing your request",
                                    "danger"
                                );
                            }
                        });
                }
            });
        }
    }
};
</script>
